import React, { memo } from 'react';
import { Box, Text, SimpleGrid, Heading, HStack, Button } from '@chakra-ui/react';

const ProductCart = memo(({ 
  cartProducts, 
  addProductToCart, 
  decreaseProductQuantity, 
  removeProductFromCart,
  selected = [] // Adicionar selected com valor padrão vazio
}) => {
  if (cartProducts.length === 0) {
    return null;
  }

  return (
    <Box
      p={6}
      bg="linear-gradient(180deg, rgba(45,55,72,0.9) 0%, rgba(26,32,44,0.9) 100%)"
      borderRadius="2xl"
      boxShadow="2xl"
      border="1px solid"
      borderColor="whiteAlpha.100"
      backdropFilter="blur(10px)"
      mb={6}
    >
      <HStack mb={6} justify="space-between" align="center">
        <Heading size="md" color="yellow.400" letterSpacing="wide">
          Produtos no Carrinho
        </Heading>
      </HStack>
      
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} className="hide-scrollbar">
        {cartProducts.map((product) => (
          <Box
            key={product.id}
            bg="whiteAlpha.50"
            _hover={{ bg: 'whiteAlpha.100', transform: 'translateY(-2px)' }}
            transition="all 0.2s"
            borderRadius="xl"
            boxShadow="lg"
            border="1px solid"
            borderColor="whiteAlpha.200"
            overflow="hidden"
            p={4}
          >
            <HStack spacing={4} align="center" justify="space-between">
              <Box flex={1}>
                <Text fontSize="lg" color="white" fontWeight="bold" mb={1}>
                  {product.nome}
                </Text>
                <Box 
                  py={1} 
                  px={3} 
                  bg="green.40020"
                  borderRadius="full"
                  border="1px solid"
                  borderColor="green.400"
                  display="inline-block"
                  mb={2}
                >
                  <Text color="green.400" fontSize="md" fontWeight="bold">
                    R$ {(product.valor * (product.quantity || 1)).toFixed(2).replace('.', ',')}
                  </Text>
                </Box>
              </Box>
              
              <Box>
                <HStack spacing={2}>
                  <Button
                    size="md"
                    colorScheme="yellow"
                    isDisabled={(product.quantity || 1) <= 1}
                    onClick={() => decreaseProductQuantity(product.id)}
                    borderRadius="xl"
                    width="40px"
                    height="40px"
                  >
                    -
                  </Button>
                  <Text color="white" fontSize="md" fontWeight="bold" mx={2}>
                    {product.quantity || 1}
                  </Text>
                  <Button
                    size="md"
                    colorScheme="yellow"
                    onClick={() => addProductToCart(product)}
                    borderRadius="xl"
                    width="40px"
                    height="40px"
                  >
                    +
                  </Button>
                </HStack>
                <Button
                  mt={3}
                  colorScheme="red"
                  size="md"
                  width="full"
                  borderRadius="xl"
                  onClick={() => {
                    // Remove todas as unidades do produto
                    for (let i = 0; i < (product.quantity || 1); i++) {
                      removeProductFromCart(product.id);
                    }
                  }}
                >
                  Remover
                </Button>
              </Box>
            </HStack>
          </Box>
        ))}
      </SimpleGrid>
      
      {/* O total de produtos foi removido e agora é exibido apenas no componente TotalGeral */}
    </Box>
  );
});

export default ProductCart;
